import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from '../baseStore';
import { RootStore } from '../rootStore';
import { LenderStatementTransactionService } from '/src/api/services/lender-statement-transaction-service';
import { Statement, Transaction } from '/src/lib/models';
import { DataModelPluralType, TListLenderStatementTransactionsRequest } from '/src/lib/types';

export interface LenderStatementTransactionsStoreProps {
  /**
   * List of Lender Statement transactions
   */
  transactions?: Transaction[];
  /**
   * List of Lender Statements
   */
  statements?: Statement[];
  /**
   * Transaction and statement totals
   */
  totals?: Record<string, number>;
  /**
   * Whether all Transactions in the list are Adjustments
   */
  allAdjustments?: boolean;
}

export class LenderStatementTransactionsStore extends BaseStore implements LenderStatementTransactionsStoreProps {
  transactions?: Transaction[];
  statements?: Statement[];
  totals?: Record<string, number>;
  allAdjustments?: boolean;

  constructor(rootStore: RootStore) {
    super(rootStore);

    makeObservable(this, {
      transactions: observable,
      statements: observable,
      totals: observable,
      allAdjustments: observable,
    });
  }

  /**** Lender Statement Transactions CRUD ****/

  /**
   * Fetches and caches a list of Lender Statements and their Transactions.
   *
   * @param filters - Filters to use when fetching Transactions
   * @returns The Lender Statement Transactions list
   */
  query = async (filters: TListLenderStatementTransactionsRequest) => {
    if (!filters.lenderId) return;

    // Execute the query and get the Transactions list
    const { transactions, totals, allAdjustments } = await LenderStatementTransactionService.query(filters);

    const statements = transactions.filter(
      (transaction) => transaction.__t === DataModelPluralType.Statement
    ) as Statement[];

    runInAction(() => {
      this.transactions = transactions;
      this.statements = statements;
      this.totals = totals;
      this.allAdjustments = allAdjustments;
    });
  };
}
